<template>
  <div
    class="cursor-pointer"
    @click.prevent="onAdsClick(material.contents.centerTitle.link)"
  >
    <PreventLink
      class="ads-type-20"
      :href="material.contents.centerTitle.linkWithJobsource"
    >
      <component :is="pageLayout" :material="material" />
    </PreventLink>
  </div>
</template>

<script>
import PreventLink from "@/components/shared/PreventLink.vue";
import { PAGE_ENUM } from "@/adsmart-ui/settings/pageLayout.js";
import MobileJobList from "./layout/MobileJobList.vue";
import MobileJobPage from "./layout/MobileJobPage.vue";
import AppJobPage from "./layout/AppJobPage.vue";

export default {
  name: "AdsType20",
  components: {
    PreventLink,
    [PAGE_ENUM.MOBILE__JOB_LIST]: MobileJobList,
    [PAGE_ENUM.MOBILE__JOB_PAGE]: MobileJobPage,
    [PAGE_ENUM.APP__JOB_PAGE]: AppJobPage
  },
  props: {
    materials: {
      type: Array,
      default: () => []
    },
    pageLayout: {
      type: String,
      default: ""
    }
  },
  computed: {
    material() {
      return this.materials[0];
    }
  },
  mounted() {
    this.$emit("ads:entry", 0);
  },
  methods: {
    onAdsClick(linkHref) {
      this.$emit("ads:click", linkHref, 0);
    }
  }
};
</script>
